import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { history } from "./utils";
import { NotificationContainer } from "react-light-notifications";
import "react-light-notifications/lib/main.css";
import { HomePage } from "./containers/HomePage";
import { StatusProntoSoccorso } from "./containers/StatusProntoSoccorso";
import { MonitoraggioPaziente } from "./containers/MonitoraggioPaziente";
import { ChiSiamo } from "./containers/ChiSiamo";
import { Faq } from "./containers/Faq";
import { NavigationProvider } from "./components/NavigationProvider";
import { InternationalizationProvider } from "./contexts/intl/InternationalizationProvider";
import { HomePageTotem } from "./containers/HomePageTotem";
import { CodiceContattoTotem } from "./containers/CodiceContattoTotem";
import { MonitoraggioTotem } from "./containers/MonitoraggioTotem";
import EncountersTrackerProvider from "./contexts/encounter/EncountersTrackerProvider";
import { PrivacyPolicy } from "./containers/PrivacyContainer";
import { Cookie } from "./components/Cookie";
import { CookiesProvider } from 'react-cookie';

export const App = () => {
  return (
    <React.Fragment>
      <EncountersTrackerProvider>
        <InternationalizationProvider>
          <CookiesProvider>
            
              <NotificationContainer />
              <Router
                history={history}
                basename={process.env.REACT_APP_ROUTER_BASE || ''}
              >
                <NavigationProvider>
                  <Switch>
                    <Route
                      exact={true}
                      path="/"
                      component={HomePage}
                    />
                    <Route
                      exact={true}
                      path="/status"
                      component={StatusProntoSoccorso}
                    />
                    <Route
                      exact={true}
                      path="/monitoraggio"
                      component={MonitoraggioPaziente}
                    />
                    <Route
                      exact={true}
                      path="/chisiamo"
                      component={ChiSiamo}
                    />
                    <Route
                      exact={true}
                      path="/faq"
                      component={Faq}
                    /> 
                    <Route
                      exact={true}
                      path="/privacy"
                      component={PrivacyPolicy}
                    />
                  </Switch> 
                  <Switch>
                    <Route
                      exact={true}
                      path="/totem"
                      component={HomePageTotem}
                    />
                    <Route
                      exact={true}
                      path="/totem/status"
                      component={CodiceContattoTotem}
                    />
                    <Route
                      exact={true}
                      path="/totem/monitoraggio/:id"
                      component={(props) => (
                        <MonitoraggioTotem
                          id={props.match.params.id}
                          history={history}
                        />
                      )}
                    />
                  </Switch>
                  <Cookie history={history} />
                </NavigationProvider>
              </Router>
          </CookiesProvider>
        </InternationalizationProvider>
      </EncountersTrackerProvider>
    </React.Fragment>
  );
};
